//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["label1", "label2", "label3", "isActive"],
  data() {
    return {};
  },
};
